var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardDef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.794,
    height: 16.794,
    viewBox: "0 0 16.794 16.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_-_def",
    "data-name": "Dashboard - def",
    transform: "translate(-66.89 -160.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "space_dashboard_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "space_dashboard_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M7.4,22.794a1.435,1.435,0,0,1-1.4-1.4V7.4A1.435,1.435,0,0,1,7.4,6h14a1.435,1.435,0,0,1,1.4,1.4v14a1.435,1.435,0,0,1-1.4,1.4Zm0-1.4h6.3V7.4H7.4Zm7.7,0h6.3V14.374H15.1Zm0-8.421h6.3V7.4H15.1Z",
    transform: "translate(60.89 154.302)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDef);
export default __webpack_public_path__ + "static/media/dashboard_def.13ba1556ee9d4ed56f273ad2f0cebbb6.svg";
export { ForwardRef as ReactComponent };